import { render, staticRenderFns } from "./LawEntity.vue?vue&type=template&id=2ab95cdb&scoped=true"
import script from "./LawEntity.vue?vue&type=script&lang=js"
export * from "./LawEntity.vue?vue&type=script&lang=js"
import style0 from "./LawEntity.vue?vue&type=style&index=0&id=2ab95cdb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab95cdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab95cdb')) {
      api.createRecord('2ab95cdb', component.options)
    } else {
      api.reload('2ab95cdb', component.options)
    }
    module.hot.accept("./LawEntity.vue?vue&type=template&id=2ab95cdb&scoped=true", function () {
      api.rerender('2ab95cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LawEntity.vue"
export default component.exports